module.exports = __webpack_public_path__ + "img/05-326x184-portannese.2742035a.jpg";